import type { DialogProps } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import clsx from "clsx";

type DialogPaperSlotProps = NonNullable<DialogProps["slotProps"]>["paper"];

type MobileDialogPaperOptions = {
	readonly className?: string;
	readonly sx?: SxProps<Theme>;
	readonly mobileSx?: SxProps<Theme>;
};

const MOBILE_DIALOG_PAPER_SX: SxProps<Theme> = {
	m: 0,
	width: "100vw",
	maxWidth: "100vw",
	height: "80vh",
	maxHeight: "80vh",
	minWidth: 0,
	minHeight: 0,
	display: "flex",
	flexDirection: "column",
	borderRadius: 0,
};

export function buildMobileDialogPaperProps(
	isMobile: boolean,
	options: MobileDialogPaperOptions = {},
): DialogPaperSlotProps {
	const { className, sx, mobileSx } = options;

	return {
		className: clsx(className, isMobile && "rounded-none"),
		sx: isMobile ? ([sx, MOBILE_DIALOG_PAPER_SX, mobileSx] as SxProps<Theme>) : sx,
	};
}
